import { render, staticRenderFns } from "./projectFilter.vue?vue&type=template&id=04607f8c&scoped=true&lang=html"
import script from "./projectFilter.vue?vue&type=script&lang=js"
export * from "./projectFilter.vue?vue&type=script&lang=js"
import style0 from "./projectFilter.vue?vue&type=style&index=0&id=04607f8c&prod&lang=css"
import style1 from "./projectFilter.vue?vue&type=style&index=1&id=04607f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04607f8c",
  null
  
)

export default component.exports